
























import { Vue, Component, InjectReactive, Prop } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import ConversationUserPermissionsModel from '@/models/crm/conversation-user-permissions.model';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import ConversationService from '@/services/crm/conversation.service';
import { ConversationContactStatusEnum } from '@/enums/crm/conversation-contact-status.enum';
import ContactModel from '@/models/crm/contact.model';
import { ICreateConversation } from '@/interfaces/crm/create-conversation.interface';
import SessionService from '@/services/session.service';
import UserContactInfo from '@/models/crm/user-contact-info.model';

@Component({})
export default class CrmChatCallerButton extends Vue {
  @inject(InjectionIdEnum.CrmConversationService)
  private conversationService!: ConversationService;

  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @InjectReactive('conversationUserPermission') readonly conversationUserPermission!: ConversationUserPermissionsModel;

  @InjectReactive('userContactInfo') readonly userContactInfo!: UserContactInfo;

  @Prop({ required: true })
  contactNumber!: string;

  @Prop()
  clientId!: string;

  @Prop()
  contact!: ContactModel;

  @Prop()
  width!: boolean | string;

  @Prop()
  height!: boolean | string;

  @Prop()
  color!: string;

  @Prop({ default: false })
  disabled!: boolean;

  loading = false;

  async onClick(): Promise<void> {
    this.loading = true;
    try {
      if (this.canOpenConversation()) {
        const checkResult = await this.conversationService.checkContactNumber(this.contactNumber);
        const validWaContact = checkResult.find((x) => x.status === ConversationContactStatusEnum.Valid);

        if (validWaContact) {
          const payload: ICreateConversation = {
            contact: this.contact,
            waContact: validWaContact,
          };
          const { apiToken, apiUrl, socketIOUrl } = this.sessionService;
          this.$store.commit('setContactNumber', this.contactNumber);
          this.$store.commit('setClientId', this.clientId);
          this.$store.commit('setCreateConversationPayload', payload);
          this.$store.commit('setUserContactInfo', this.userContactInfo);
          const chatWindowName = 'GeoChatWindow';
          const chatWindowUrl = this.$router.resolve({
            name: 'GeoChatView',
            query: {
              token: apiToken,
              apiUrl,
              socketIOUrl,
            },
          }).href;
          let chatWindow = window.open('', chatWindowName);
          if (!chatWindow || chatWindow.closed) {
            chatWindow = window.open(chatWindowUrl, chatWindowName);
          } else {
            chatWindow.location.href = chatWindowUrl;
            chatWindow.focus();
          }
          this.loading = false;
        } else {
          this.$notify.warn(
            this.$t('crm.chatCallerButton.messages.couldNotFoundAValidWaIdForNumber', {
              contactNumber: this.contactNumber,
            }),
            5000,
          );
        }
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loading = false;
    }
  }

  get showButton(): boolean {
    return !!this.conversationUserPermission;
  }

  private canOpenConversation(): boolean {
    if (!this.conversationUserPermission) {
      this.$notify.error(this.$t('crm.chatCallerButton.messages.errorOnGetPermissions'), 5000);
      return false;
    }

    if (!this.conversationUserPermission.viewWhatsApp) {
      this.$notify.warn(this.$t('crm.chatCallerButton.messages.whatsappDisabled'), 5000);
      return false;
    }

    if (!this.conversationUserPermission.manageWhatsApp) {
      this.$notify.warn(this.$t('crm.chatCallerButton.messages.youDoNotHavePermissiontoManageWhatsApp'), 5000);
      return false;
    }

    return true;
  }
}
